import { useState } from 'react';
import { ITag } from './tag.models';
import * as S from './tag.style';

export const Tag: React.FC<ITag> = ({
  children,
  variant = 'white',
  type = 'default',
  isSelected = false,
  onClick, // filtering callback
}) => {
  // Internally handled
  const [isHover, setIsHover] = useState(false);

  const handleClick = () => {
    // setIsActive(!isActive);
    if (onClick) {
      onClick();
    }
  };

  return (
    <S.Li
      variant={variant}
      type={type}
      isSelected={isSelected}
      isHover={isHover}
      onClick={handleClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {children}
    </S.Li>
  );
};
